import UAHelper from '../utils/uaHelper';
import EnvHelper from '../utils/appEnvironmentHelper';
import MAppTracker from './MAppTracker';
import PlatformTracker from './PlatformTracker';
import WebTracker from './WebTracker';

export default class TrackerFactory {
  createTracker(tenantName: string) {
    let tracker: PlatformTracker;
    if (this._isAndroidBridgeSupported()) {
      tracker = new MAppTracker();
    } else {
      // todo: fix MAppTracker to work in iOS
      tracker = new WebTracker(tenantName);
    }
    return tracker;
  }
  private _isAndroidBridgeSupported() {
    return (
      UAHelper.isAndroid() &&
      typeof window.Android?.ingestEvent === 'function' &&
      typeof window.Android?.pushEvents === 'function'
    );
  }
  private _isIOSBridgeSupported() {
    const appVersion = EnvHelper.getAppVersion() || '';
    return (
      UAHelper.isIOS() &&
      EnvHelper.compareAppVersion({ appVersion, baseVersion: '5.3.0' })
    );
  }
}
